
export function getReadableDateTime(timeStamp){
    let date = new Date(timeStamp)
    return date.toLocaleString()
}

export const getSideNestedNav = () => JSON.parse(localStorage.getItem('sidenavnested'))
export const setSideNestedNav = (val) => localStorage.setItem('sidenavnested', val)